import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading region " + _toDisplayString(_ctx.regionId), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.region.name), 1),
            _createElementVNode("p", null, "Koordinaten: " + _toDisplayString(_ctx.region.lat) + ", " + _toDisplayString(_ctx.region.lng), 1),
            (_ctx.region.manager)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createTextVNode("Gebietsleiter: " + _toDisplayString(_ctx.region.manager.prename) + " " + _toDisplayString(_ctx.region.manager.surname) + " (", 1),
                  _createElementVNode("a", {
                    href: `mailto:${_ctx.region.manager.email}`
                  }, _toDisplayString(_ctx.region.manager.email) + ")", 9, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}